import React from 'react';
import { useLocation } from 'react-router-dom';
import ConversationsLayout from '../../components/layout/ConversationsLayout';

export default function ConversationsPage() {
  const { pathname } = useLocation();
  let mode = 'default';
  if (pathname.includes('/mentions')) mode = 'mentions';
  else if (pathname.includes('/unattended')) mode = 'unattended';
  return <ConversationsLayout mode={mode} />;
}
